import api from "../../utils/apiPublic";

export async function obtenerConfiguracionTiendaPublic() {
  try {
    const { data } = await api.get("/api/public/configuracion");
    return data?.data ?? null;
  } catch {
    return null;
  }
}
